export const getEnvSessionData = () =>
  JSON.parse(sessionStorage.getItem('environment'));
